import { render } from "./TaskPostType.vue?vue&type=template&id=1823ca5e"
import script from "./TaskPostType.vue?vue&type=script&lang=js"
export * from "./TaskPostType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__